import styled from 'styled-components'
import { DropdownButton } from 'react-bootstrap'

export const SlipContainer = styled.div`
  display: grid;
  gap: 16px;
`

export const StyledDropdownButton = styled(DropdownButton)`
  & > .dropdown-toggle {
    padding: 4px 8px;
  }
`

export const SectionTitleContainer = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
`
